import React, { useEffect, useState } from 'react';
import { ContactService } from 'services';
import { MAILING_STATUS } from 'helpers/constants';
import { useIsUser, useStore } from 'hooks';
import Menu from 'components/menu';
import Table from 'components/table';
import Actions from 'components/table/actions';
import Modal from 'components/modal';
import Contact from 'components/modal/contact';
import styles from './contacts.module.scss';

const ContactsPage = ({
  match: {
    params: { userId },
  },
}) => {
  const { reload, setUser, setLoading, setReload } = useStore();
  const [edit, setEdit] = useState(null);
  const [modal, setModal] = useState(false);
  const [contacts, setContacts] = useState([]);
  const isUser = useIsUser();

  useEffect(() => {
    (async () => {
      setLoading(true);

      const contactsResponse = await new ContactService({ setUser }).getContacts({ userId });
      if (contactsResponse) {
        setContacts(contactsResponse);
      }

      setLoading(false);
    })();
  }, [reload, userId, setUser, setLoading]);

  const onOpenModal = () => setModal(true);

  const onCloseModal = (isReload = false) => {
    setEdit(null);
    setModal(false);
    if (isReload) {
      setReload();
    }
  };

  const onDelete = async ({ id: deleteId }) => {
    await new ContactService({ setUser }).deleteContact(deleteId);
    setReload();
  };

  const cells = [{
    name: 'ФИО',
    renderField: 'name',
  }, {
    name: 'Должность',
    renderField: 'position',
  }, {
    name: 'Телефон',
    renderField: 'phone',
    nowrap: true,
  }, {
    name: 'E-mail',
    renderField: 'email',
    nowrap: true,
  }, {
    name: 'Включен в рассылку',
    nowrap: true,
    onRender: ({ isMailing }) => MAILING_STATUS.toString(Number(isMailing)),
  }, ...(isUser ? [{
    name: '',
    right: true,
    nowrap: true,
    onRender: item => (
      <Actions
        data={[{
          name: 'edit',
          title: 'Редактировать',
          onClick: () => {
            setEdit(item);
            setModal(true);
          },
        }, {
          name: 'cart',
          title: 'Удалить',
          onClick: () => onDelete(item),
        }]}
      />
    ),
  }] : [])];

  return (
    <>
      <div className={styles.menu}>
        <Menu onAdd={isUser ? onOpenModal : false} />
      </div>
      <div className={styles.table}>
        <Table cells={cells} data={contacts} />
      </div>
      {isUser && modal ? (
        <Modal closeBackground={false} onClose={onCloseModal}>
          <Contact edit={edit} onClose={onCloseModal} />
        </Modal>
      ) : null}
    </>
  );
};

export default ContactsPage;
